import { render, staticRenderFns } from "./charttable.vue?vue&type=template&id=18bd2b7d&scoped=true&"
import script from "./charttable.vue?vue&type=script&lang=js&"
export * from "./charttable.vue?vue&type=script&lang=js&"
import style0 from "./charttable.vue?vue&type=style&index=0&id=18bd2b7d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18bd2b7d",
  null
  
)

export default component.exports